import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'surface-analysis-legend-svg',
  templateUrl: './surface_analysis_legend.svg',
  styleUrl: './surface-analysis-legend-svg.css',
  standalone: true,
  imports: [CommonModule]
})
export class SurfaceAnalysisSvgComponent {}
